import {
    getPriceRangeRent,
    getPriceRangeSale,
    getProductId,
    getProductName,
} from '@/app/_helper/property';
import { convertEpochTimeToISOFormat } from '@/app/_helper/time';

import { ListingDetail } from '../_presentation/type';

/**
 * @param listing
 * @returns GA4 Object For old GTM (Old GTM = GTM93)
 */
const createListingObject = (listing: ListingDetail): Listing => {
    return {
        agent: {
            id: listing.agent?.originId,
            name: listing.agent?.name,
            type: 'agent',
            agencyId: listing.agent?.agencyId,
            agency: listing.agent?.agencyName,
        },
        channel: listing.priceType == 0 ? 'sale' : 'rent',
        createdDate: convertEpochTimeToISOFormat(listing.time?.updated ?? 0),
        expiredDate: '',
        id: listing.originId,
        image: listing.media?.cover,
        link: process.env.NEXT_PUBLIC_AUTH_HOST_URL + (listing.url || ''),
        latitude: listing.location?.latitude,
        longitude: listing.location?.longitude,
        isPriceDrop: false,
        market: 'local',
        maxPrice: listing.price?.offer,
        minPrice: listing.price?.offer,
        parentId: '',
        price: listing.price?.offer as unknown as string,
        priceCurrency: 'IDR',
        priceRangeSale:
            listing.priceType == 0
                ? getPriceRangeSale(listing.price?.offer || 0)
                : getPriceRangeRent(listing.price?.offer || 0),
        product: {
            id: getProductId(listing.subscription?.id || 1),
            name: getProductName(listing.subscription?.id || 1, false),
            subname: '',
        },
        projectStatus: 'Active',
        property: {
            bathrooms: listing.attrs?.common.bathroom,
            bedrooms: listing.attrs?.common.bedroom,
            carparks: listing.attrs?.common.carport,
            developer: '',
            direction: listing.attrs?.exterior.facing,
            facilities: [
                ...(listing.facilities?.house || []),
                ...(listing.facilities?.residential || []),
            ],
            floor: listing.attrs?.exterior.floors,
            furnishing: listing.attrs?.interior.furnishType,
            id: listing.originId,
            locationAddress: listing.location?.text,
            locationLevel1: listing.location?.province.name
                .toLowerCase()
                .replace(/\s+/g, '-'),
            locationLevel2: listing.location?.city.name
                .toLowerCase()
                .replace(/\s+/g, '-'),
            locationLevel3: listing.location?.district.name
                .toLowerCase()
                .replace(/\s+/g, '-'),
            name: listing.title,
            size1: listing.attrs?.common.landSize,
            size2: listing.attrs?.common.builtSize,
            storey: '',
            tenure: '',
            type: listing.listingType?.toString(),
        },
        status: 'Active',
        subscriptionTierId: listing.subscription?.id,
        subtitle: '',
        title: listing.title,
        totalUnits: 0,
        updateDate: convertEpochTimeToISOFormat(listing.time?.updated ?? 0),
    };
};

export default createListingObject;
